import React, { forwardRef } from 'react';

export const Record = forwardRef((_, ref) => (
  <svg
    fill="none"
    height="12"
    ref={ref}
    viewBox="0 0 13 12"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.56586" cy="6" fill="#FF4F4F" r="5" />
    <circle cx="6.56604" cy="6" r="5.75" stroke="#FF4F4F" strokeWidth="0.5" />
  </svg>
));
